import { render, staticRenderFns } from "./TitleContent.vue?vue&type=template&id=2f7af61b&functional=true&"
import script from "./TitleContent.vue?vue&type=script&lang=js&"
export * from "./TitleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports